import cn from "classnames";

import Dropzone from "@ui-kit/Dropzone/Dropzone";

import s from "../../ContentBlock.module.scss";
const DropzoneBlock = ({
  file,
  updateField,
  isWidget,
  isWidgetEditing,
  isVertical,
}) => {
  return (
    <Dropzone
      useModal
      allowThreeD
      allowVideo
      className={cn(
        s.graphicFile,
        isVertical && s.isVertical,
        s.dropdown,
        !file.src && s.empty,
      )}
      // onDrop={(path) => {
      //   updateField({
      //     name: "image",
      //     value: {
      //       ...file,
      //       src: path,
      //     },
      //   });
      // }}
      unoptimized
      preview={file.src}
      removeImage={() => {
        updateField({
          name: "image",
          value: {
            ...file,
            src: "",
          },
        });
      }}
    />
  );
};

export default DropzoneBlock;
